type QueryKeys<T extends string> = {
  all: [T];
  lists: [T, 'lists'];
  list: (params: Record<string, unknown>) => [T, 'lists', typeof params];
  details: [T, 'details'];
  detail: (id: string | number) => [T, 'details', typeof id];
};

export function generateQueryKeys<T extends string>(base: T): QueryKeys<T> {
  return {
    all: [base],
    lists: [base, 'lists'],
    list: (params) => [base, 'lists', params],
    details: [base, 'details'],
    detail: (id) => [base, 'details', id],
  };
}
